module.exports = __webpack_public_path__ + "img/project-icon.834648f5.svg";